// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"unsearchable-search-bar_wrapper__2MT7c","searchBar":"unsearchable-search-bar_searchBar__1mtCj"};